import { useEffect, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { NexaMark } from './nexa-mark';
import { useNexaQueryActivity } from './use-nexa-query-activity';

export const NEXA_ACTIVITY_SLOT_ID = 'nexa-activity-slot';

export function NexaQueryActivity() {
  const activity = useNexaQueryActivity();
  const { t } = useTranslation();
  const [slot, setSlot] = useState<HTMLElement | null>(null);

  // Portal into the topbar slot so the mark lives in chrome without coupling TopBar to react-query.
  useLayoutEffect(() => {
    setSlot(document.getElementById(NEXA_ACTIVITY_SLOT_ID));
  }, [activity]);

  useEffect(() => {
    if (!slot) return;
    slot.classList.toggle('nexa-activity-slot--busy', activity === 'compact');
    return () => slot.classList.remove('nexa-activity-slot--busy');
  }, [slot, activity]);

  // Initial route-data load ('splash' state): a hairline progress bar at the very
  // top of the chrome — NEVER a fullscreen overlay. The app shell stays visible
  // and each route's own skeletons carry the body; fullscreen splashes are
  // reserved for real app boots (login / auth callback / Auth0 redirect).
  if (activity === 'splash') {
    return createPortal(
      <div
        className="nexa-route-progress"
        role="progressbar"
        aria-busy="true"
        aria-label={t('nexa.loading')}
        data-testid="nexa-route-progress"
      >
        <div className="nexa-route-progress__bar" />
      </div>,
      document.body,
    );
  }

  if (activity === 'compact' && slot) {
    return createPortal(<NexaMark variant="compact" />, slot);
  }

  return null;
}
